import type React from 'react';

import { Tooltip, type TooltipProps, withStyles } from '@material-ui/core';
import type { Data } from 'popper.js';

import { colors, fonts } from '../styles';

const StylesHintPopup = withStyles({
  arrow: {
    color: colors.secondary.default,
  },
  tooltip: {
    backgroundColor: colors.secondary.default,
    color: colors.white,
    padding: '5px 10px',
    fontSize: fonts.size.smallest,
    fontWeight: fonts.weight.medium,
  },
  tooltipPlacementBottom: {
    margin: '10px 0 0 0',
  },
  tooltipPlacementLeft: {
    margin: '0 10px 0 0',
  },
  tooltipPlacementTop: {
    margin: '0 0 10px 0',
  },
  tooltipPlacementRight: {
    margin: '0 0 0 10px',
  },
})(Tooltip);

export interface HintPopupProps extends TooltipProps {
  enabled?: boolean;
  noArrowDisplacement?: boolean;
}

export const HintPopup: React.FC<HintPopupProps> = ({
  placement,
  children,
  noArrowDisplacement = false,
  enabled = true,
  ...props
}) => {
  const getArrowPosition = (data: Data) => {
    const newData = data;

    if (placement === 'bottom-end' || placement === 'top-end') {
      newData.arrowStyles.right = '10';
      newData.arrowStyles.left = 'auto';
    } else if (placement === 'bottom-start' || placement === 'top-start') {
      newData.arrowStyles.left = '10';
    } else if (placement === 'left-end' || placement === 'right-end') {
      newData.arrowStyles.bottom = '5';
      newData.arrowStyles.top = 'auto';
    } else if (placement === 'left-start' || placement === 'right-start') {
      newData.arrowStyles.top = '5';
    }

    return newData;
  };

  return enabled ? (
    <StylesHintPopup
      placement={placement}
      PopperProps={{
        modifiers: {
          offset: noArrowDisplacement
            ? undefined
            : { enabled: true, fn: getArrowPosition },
        },
        style: { zIndex: 9999 },
        ...props.PopperProps,
      }}
      {...props}
    >
      {children}
    </StylesHintPopup>
  ) : (
    children
  );
};
